import React from "react"

const Logo = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>NR</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g>
        <rect
          id="Rectangle"
          fill="#000000"
          x="0"
          y="0"
          width="40"
          height="40"
        ></rect>
        <path
          d="M11.0582625,27.52 L11.0582625,17.6024588 L17.7266543,27.52 L20.44,27.52 L20.44,12.52 L17.3817375,12.52 L17.3817375,21.8753223 L11.1732348,12.52 L8,12.52 L8,27.52 L11.0582625,27.52 Z M23.16,21.9427886 L24.8179028,21.9427886 L28.5652174,27.52 L32.04,27.52 L28.1564194,21.7643178 C28.7771867,21.5858471 29.3108951,21.3404498 29.7575448,21.0281259 C30.2041944,20.7158021 30.5675703,20.3551424 30.8476726,19.9461469 C31.1277749,19.5371514 31.3359591,19.0872564 31.4722251,18.5964618 C31.608491,18.1056672 31.676624,17.5925637 31.676624,17.0571514 C31.676624,16.1796702 31.5138619,15.4583508 31.1883376,14.8931934 C30.8628133,14.328036 30.446445,13.8781409 29.9392327,13.5435082 C29.4320205,13.2088756 28.8604604,12.9746327 28.2245524,12.8407796 C27.5886445,12.7069265 26.9527366,12.64 26.3168286,12.64 L23.16,12.64 L23.16,27.52 L23.16,21.9427886 Z M25.4753719,19.36 L23.16,19.36 L23.16,15.16 L25.4753719,15.16 C26.6293113,15.16 27.4385675,15.3368817 27.9031405,15.6906452 C28.3677135,16.0444086 28.6,16.5825806 28.6,17.3051613 C28.6,17.9825806 28.3527273,18.4944086 27.8581818,18.8406452 C27.3636364,19.1868817 26.5693664,19.36 25.4753719,19.36 L25.4753719,19.36 Z"
          id="NR-Copy"
          fill="#FFFFFF"
          fill-rule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
)

export default Logo
